import React, { useState } from "react";
import AddAcpProgram from "./pages/add_acp_programs";
import ShowPrograms from "./pages/show-acp-programs";
import { Button } from "primereact/button";

export default function AcpProgramsFlowPage() {
  // -------------------- STATE --------------------
  const [addAcpPage, setAcpPage] = useState(false); // controls Add Program view
  const [editAcp, setEditAcp] = useState(false); // controls Edit Program state

  // -------------------- HANDLERS --------------------
  const handleAddClick = () => setAcpPage(true);
  const handleBackClick = () => setAcpPage(false);

  // -------------------- UI --------------------
  return (
    <div className="card" style={{ position: "relative" }}>
      {/* ---------- Action Buttons ---------- */}
      {!addAcpPage ? (
        !editAcp && (
          <div style={{ position: "absolute", right: "3rem" }}>
            <Button
              label="Add New"
              style={{ width: "11rem" }}
              onClick={handleAddClick}
            />
          </div>
        )
      ) : (
        <div>
          <Button
            label="Back"
            style={{ width: "11rem" }}
            onClick={handleBackClick}
          />
        </div>
      )}

      {/* ---------- Content Section ---------- */}
      <div>
        {!addAcpPage ? (
          <ShowPrograms setEditAcp={setEditAcp} />
        ) : (
          <AddAcpProgram />
        )}
      </div>
    </div>
  );
}
